<template>
  <el-dialog title="订单详情" @open="openDialog" @close="closeDialog" :visible.sync="isShow" width="800px" center class="order-detail-dialog" :close-on-click-modal="false">
    <el-form label-width="100px">
      <div class="order-detail-yto-box">
        <el-row>
          <div class="yto-title">发件人信息</div>
          <el-col :span="8">
            <el-form-item label="发件人姓名">
              <el-input :value="data.sendName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手机号码">
              <el-input :value="data.sendMobile" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电话号码">
              <el-input :value="data.sendPhone" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-form-item label="发件地址">
            <el-input :value="data.sendCity" disabled></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <div class="yto-title">收件人信息</div>
          <el-col :span="8">
            <el-form-item label="收件人姓名">
              <el-input :value="data.postReceiver|| ''" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手机号码">
              <el-input :value="data.postTel|| ''" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电话号码">
              <el-input :value="data.receiveMobile|| ''" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-form-item label="收件地址">
            <el-input :value="data.postProvince|| '' + data.postCity|| '' + data.postTown|| '' + data.postStreet|| '' + data.postDetail|| ''" disabled></el-input>
          </el-form-item>
        </el-row>
      </div>
      <div class="order-detail-yto-box mt20">
        <el-row>
          <div class="yto-title">商品信息</div>
          <el-col :span="24" class="nProductsStyle y-fs-12">
            <div style="padding:20px;">
              <table class="table">
                <thead>
                <th>商品名称</th><th>规格</th><th>数量</th><th>单价</th>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in data.items" :key="index">
                    <td>{{item.productName}}</td><td>{{item.specifications}}</td><td>{{item.comboNum}}</td><td>{{item.comboAmount}}</td>
                  </tr>
                  <tr>
                    <td colspan = "4" style="text-align:left;">
                      <span>合计数量：</span><span>{{data.comboNum}} 个</span>
                      <!-- <span class="ml15">实付总额：</span><span>90</span> -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <el-col :span="12">
              <el-form-item label="卖家备注">
                <el-input :value="data.sellerWords" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="买家留言">
                <el-input :value="data.buyerWords" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
      </div>
      <div class="order-detail-yto-box mt20">
        <el-row class="productTimeInfoSytle y-fs-12">
          <el-col>
            <div class="yto-title">时间信息</div>
            <el-col :span="12"><span class="tit">下单时间：</span><span class="content">{{data.createTime}}</span></el-col>
            <el-col :span="12"><span class="tit">打印快递单时间：</span><span class="content">{{data.waybillPrintTime ? data.waybillPrintTime.replace('T', ' ').substring(0, 19) : ''}}</span></el-col>
            <el-col :span="12"><span class="tit">打印发货单时间：</span><span class="content">{{data.deliverPrintTime ? data.deliverPrintTime.replace('T', ' ').substring(0, 19) : ''}}</span></el-col>
            <el-col :span="12"><span class="tit">订单号码：</span><span class="content">{{data.orderId}}</span></el-col>
            <el-col :span="12"><span class="tit">状态：</span><span class="content" v-text="getOrderStatus(data.orderStatus)"></span></el-col>
            <el-col :span="12"><span class="tit">打印快递单次数：</span><span class="content">{{data.printNum > 0 ? data.printNum : ''}}</span></el-col>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div class="detail-dialog-footer" style="margin-top: 20px;text-align:center;">
      <el-button @click="closeDialog" type="primary">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  props: {
    info: {
      type: String
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(val) {
      this.isShow = val;
    }
  },
  data() {
    return {
      isShow: this.value,
      data: {
        sendName: '',
        sendMobile: '',
        sendPhone: '',
        sendCity: '',
        sendAddress: '',
        receiverName: '',
        receiveMobile: '',
        receiverTel: '',
        receiveCity: '',
        receiveAddress: '',
        items: [],
        buyerMemo: '',
        remark: '',
        createTime: '',
        confirmTime: '',
        orderSn: '',
        waybillPrintTime: '',
        deliverPrintTime: '',
        deliverPrintStatus: '',
        waybillPrintCount: 0,
      },
      orderStatusOpts: [
        {name: '全部', value: ''},
        {name: '待确认', value: '0'},
        {name: '待付款', value: '1'},
        {name: '待发货', value: '2'},
        {name: '已发货', value: '3'},
        {name: '已完成', value: '4'},
        {name: '已关闭', value: '5'},
        {name: '退货中', value: '6'},
        {name: '退款中', value: '7'}
      ]
    };
  },
  methods: {
    openDialog() {
      if (this.info) {
        let infomation = JSON.parse(this.info);
        if (infomation.orderProducts) {
          infomation.items = infomation.orderProducts;
          // infomation.items.forEach(item => {
          //   let specList = item.specDesc ? JSON.parse(item.specDesc) : [];
          //   item.goodStyle = specList.map(item => { return item.value; }).join('/');
          // });
        }
        this.data = {...this.data, ...infomation};
      }
    },
    closeDialog() {
      this.isShow = false;
      this.$emit('close', this.isShow);
    },
    getOrderStatus(val) {
      let str = '';
      this.orderStatusOpts.forEach(item => {
        if ((item.value + '') === val) {
          str = item.name;
        }
      });
      return str;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss" scoped>
@import "../../../../styles/variables";
.order-detail-yto-box {
  background-color: $white;
  padding-left: 10px;
  padding-right: 20px;
  .yto-title {
    color: $color-style;
    font-weight: 600;
    font-size: 14px;
  }
  .mt20 {
    margin-top: 20px!important;
  }
}
.order-detail-yto-box.mt20 {
  margin-top: 20px;
}
.nProductsStyle .table {
  width:100%;
  border-top: 1px solid #DCDFE6;
  border-bottom: 1px solid #DCDFE6;
  th {
    width: 14.28%;
    height:30px;
    font-weight: normal;
    color: #000;
  }
  tr td {
    height:30px;
    border-top:1px solid #DCDFE6;
    text-align: center;
  }
  .ml15 {
    margin-left: 15px;
  }
}
.productTimeInfoSytle {
  padding-bottom: 20px;
  .el-col{
    line-height: 32px;
    .tit {
      display: inline-block;
      width: 120px;
      color :#000;
      text-align: right;
      display: inline-block;
      word-break: break-all;
    }
    .content {
      display: inline-block;
      word-break: break-all;
    }
  }
}
</style>
